import React, { useState } from "react";
import styled from "styled-components";
import { FaBars, FaTimes } from "react-icons/fa";

const Nav = styled.nav`
  background: ${(props) => props.theme.navbar};
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
`;

const Logo = styled.h2`
  color: ${(props) => props.theme.navbarText};
  font-size: 1.5rem;
  font-weight: bold;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 1.5rem;

  a {
    color: ${(props) => props.theme.navbarText};
    text-decoration: none;
    font-size: 1rem;
    font-weight: bold;
    transition: color 0.3s ease-in-out;

    &:hover {
      color: ${(props) => props.theme.navbarHover};
    }
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileMenu = styled.div`
  position: absolute;
  top: 60px; /* Positioned below the navbar */
  left: ${({ isOpen }) => (isOpen ? "0" : "-50%")};
  width: 50%;
  height: 200px; /* Small size, not full height */
  background: ${(props) => props.theme.navbar};
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 1rem 2rem;
  transition: left 0.3s ease-in-out;
  border-radius: 0 10px 10px 0;
`;

const CloseIcon = styled.div`
  align-self: flex-end;
  font-size: 1.5rem;
  color: ${(props) => props.theme.navbarText};
  cursor: pointer;
`;

const MobileLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  a {
    color: ${(props) => props.theme.navbarText};
    text-decoration: none;
    font-size: 1rem;
    font-weight: bold;

    &:hover {
      color: ${(props) => props.theme.navbarHover};
    }
  }
`;

const MenuIcon = styled.div`
  display: none;
  font-size: 1.8rem;
  color: ${(props) => props.theme.navbarText};
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
  }
`;

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Nav>
      <Logo>Irene.dev</Logo>

      <MenuIcon onClick={() => setIsOpen(true)}>
        <FaBars />
      </MenuIcon>

      <NavLinks>
        <a href="#home">Home</a>
        <a href="#about">About</a>
        <a href="#experience">Experience</a>
        <a href="#projects">Projects</a>
        <a href="#contact">Contact</a>
      </NavLinks>

      {/* Mobile Menu */}
      <MobileMenu isOpen={isOpen}>
        <CloseIcon onClick={() => setIsOpen(false)}>
          <FaTimes />
        </CloseIcon>
        <MobileLinks>
          <a href="#home" onClick={() => setIsOpen(false)}>
            Home
          </a>
          <a href="#about" onClick={() => setIsOpen(false)}>
            About
          </a>
          <a href="#experience" onClick={() => setIsOpen(false)}>
            Experience
          </a>
          <a href="#projects" onClick={() => setIsOpen(false)}>
            Projects
          </a>
          <a href="#contact" onClick={() => setIsOpen(false)}>
            Contact
          </a>
        </MobileLinks>
      </MobileMenu>
    </Nav>
  );
}

export default Navbar;
